// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3gwJ2","header":"MessagesList_header__VpqnW","chat":"MessagesList_chat__2S2gf"};